import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import WithModal from "Components/withModal";
import React, { useCallback, useEffect, useState } from "react";
import AccessLevelsCreator from "./accessLevelsCreator";
import locale from "./accessLevelsCreatorPanel.locale";
export const SIZES = {
    MODAL_WIDTH: 400,
    MODAL_HEIGHT: 262
};
export default function AccessLevelsCreatorPanel(props) {
    const [show, setShow] = useState(false);
    useEffect(() => {
        setShow(Boolean(props.accessLevelNew));
    }, [props.accessLevelNew]);
    const handleHideModal = useCallback(() => {
        props.onClose && props.onClose();
    }, [props.onClose]);
    const handleClose = useCallback(() => {
        props.onClose && props.onClose();
    }, [props.onClose]);
    return (React.createElement(WithModal, { show: show, onHide: handleHideModal, contentClassName: "modal-padding", shadingColor: shadingLightestColor, className: "bg-blur", title: locale.TITLE, defaultWidth: SIZES.MODAL_WIDTH, defaultHeight: SIZES.MODAL_HEIGHT, isLoading: props.inProgress },
        React.createElement(AccessLevelsCreator, { onHide: handleClose, data: props.data, entityId: props.entityId, entityType: props.entityType, userCreate: props.userCreate })));
}
